import React from 'react'
import { StyledCard } from './Styled'

const ShadowCard = ({ children }) => {
  return <StyledCard>{children}</StyledCard>
}

export default ShadowCard
